export const GET_DOG_BEGIN = "GET_DOG_BEGIN";
export const GET_DOG_SUCCESS = "GET_DOG_SUCCESS";
export const GET_DOG_ERROR = "GET_DOG_ERROR";
export const HANDLE_SEARCH = "HANDLE_SEARCH";
